/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-concat */
import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Typography, Button } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import TrendsCertGraph from './TrendsCertGraph';

const TrendsCertified = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [certiGraph, setCertiGraph] = useState([]);

  const userInfo = !!localStorage.getItem('loginID') && JSON.parse(localStorage.getItem('loginID'));
  const { activeMenu } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        getCertifiedTrends();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(new Date());
    }
  }, [startDate]);

  const getCertifiedTrends = async () => {
    const month = startDate.getMonth() + 1;
    const year = startDate.getFullYear();

    setLoading(true);
    try {
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Certified Trends',
        Month: month,
        Year: year,
      };

      const response = await axios.post(
        `${variables.BASE_URL}CertifiedTrends`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess && Data.IsAuthorize) {
        // setGraphData(Data.ReceivingTrend);
        setCertiGraph(Data.CertifiedTrends);
      } else if (!Data.IsAuthorize) {
        setCertiGraph([]);
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      } else {
        setCertiGraph([]);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      }
    } catch (error) {
      setCertiGraph([]);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    }
    setLoading(false);
  };
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}

      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full " id="navMenu_id" style={{ background: 'linear-gradient(to right, #060047 , #00FFFF  )', borderRadius: '10px' }}>
          <Navbar />
          <div className="container-fluid d-flex justify-content-center align-items-center py-3" id="commondatePicker_id" style={{ marginBottom: '-100px' }}>
            <div className="row justify-content-center align-items-center gx-2" style={{ padding: '5px', marginTop: '-60px' }} id="datePicker_id2">
              <div className="col-12 col-md-4 d-flex align-items-center mb-2 mb-md-0">
                <Typography variant="h6">
                  Month & Year
                </Typography>
              </div>
              <div className="col-12 col-md-6 mb-2 mb-md-0">
                {loading ? (
                  <DatePicker
                    id="datePicker_id"
                    disabled
                    className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
                    dateFormat="MM/yyyy"
                    selected={startDate}
                  />
                ) : (
                  <DatePicker
                    id="datePicker_idstrt"
                    className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    minDate={new Date(2022, 0)}
                    maxDate={new Date()}
                    placeholderText="Select month and year"
                    autoComplete="off"
                  />
                )}
              </div>
              <Button onClick={getCertifiedTrends} variant="contained" size="medium" className="col-xs-6 col-sm-4 col-md-2 col-lg-2">
                Search
              </Button>
            </div>
          </div>
        </div>
        <div>
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="graph_paper">
                <TrendsCertGraph certiGraph={certiGraph} loading={loading} setLoading={setLoading} />
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendsCertified;
